import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';

export const dsTheme = dsTokens;

export const FILTER_DRAWER_FOOTER_HEIGHT = '90px';
export const SMALL_TOP_BAR_HEIGHT = '73px';
export const LARGE_TOP_BAR_HEIGHT = '146px';
export const BOTTOM_MENU_HEIGHT = '69px';
export const SMALL_SCREEN_WIDTH_MOBILE = 400;
export const DESKTOP_BREAKPOINT_WIDTH_HEADER = '1084px';

export const DESTINY_WIDTH_BREAKPOINT = 1313;
export const LOCALIZATION_WIDTH_BREAKPOINT = 1123;

export const BREAKPOINTS = {
  min: {
    sm: parseFloat(dsTheme.breakpoint.sm.minWidth),
    md: parseFloat(dsTheme.breakpoint.md.minWidth),
    lg: parseFloat(dsTheme.breakpoint.lg.minWidth),
    xlg: parseFloat(dsTheme.breakpoint.xlg.minWidth),
  },
  max: {
    sm: parseFloat(dsTheme.breakpoint.sm.maxWidth),
    md: parseFloat(dsTheme.breakpoint.md.maxWidth),
    lg: parseFloat(dsTheme.breakpoint.lg.maxWidth),
  },
};
